import ProfileReport from '@pages/profile/pages/report';
import { decryptUserStorage } from '@reducers/UserSlice';
import { Permissions } from '@utils/constants/permissions';

import ProfileSecyurity from '../../pages/profile/pages/profile-secyurity/ProfileSecyurity';
import ProfileClientInfo from '../../pages/profile/profile-client-info/ProfileClientInfo';

import { profilePaths } from './profilePaths';

const user = decryptUserStorage;

const routes = [
  {
    path: profilePaths.INDEX,
    exact: true,
    component: ProfileClientInfo
  },
  {
    path: profilePaths.SECYURITY,
    exact: true,
    component: ProfileSecyurity
  },
  {
    path: profilePaths.REPORT,
    exact: true,
    component: ProfileReport,
    permission: [Permissions.PERMISSION_SUMMARY_INSIGHT]
  }
];

export const profileRoutes: typeof routes = [];

if (typeof user === 'object' && user) {
  routes.forEach(route => {
    if (route.permission) {
      if (user?.role) {
        if (route.permission?.every(p => user.role.permissions.includes(p))) {
          profileRoutes.push(route);
        }
      } else if (user?.roleTokens && route.permission?.every(p => user.roleTokens![0]?.role?.permissions.includes(p))) {
        profileRoutes.push(route);
      }
    } else {
      profileRoutes.push(route);
    }
  });
}
